import { InnerHTMLDiv, OdinIcon } from '@myosh/odin-components';
import React, { forwardRef, type Ref, useImperativeHandle, useState } from 'react';

interface AIAnalysisSuggestionContainerProps {}

export interface AIAnalysisSuggestionContainerRef {
  show: (text: string) => void;
}

export const AIAnalysisSuggestionContainer = (
  _props: AIAnalysisSuggestionContainerProps,
  ref: Ref<AIAnalysisSuggestionContainerRef>
): React.JSX.Element => {
  const [suggestion, setSuggestion] = useState<string>();

  const show = (suggestion: string) => {
    setSuggestion(suggestion);
  };

  useImperativeHandle(ref, () => {
    return { show };
  });

  const handleClickClose = () => {
    setSuggestion(undefined);
  };

  if (!suggestion) {
    return <></>;
  }

  return (
    <div
      data-cy="ai-analysis-suggestion-container"
      className="border-gray-1 bg-mono-1 mt-4 mb-4 ml-16 flex h-fit max-h-[200px] w-[75%] flex-col rounded-sm border p-4"
    >
      <div className="flex cursor-pointer flex-row items-center justify-between">
        <label data-cy="ai-analysis-title" className="font-bold">
          AI Analysis
        </label>
        <div data-cy="ai-analysis-close-button" onClick={handleClickClose}>
          <OdinIcon icon="X" />
        </div>
      </div>

      <hr className="border-gray-4 mt-4 mb-4" />

      <div
        data-cy="ai-analysis-content-wrapper"
        className="flex h-full max-h-[200px] overflow-x-hidden overflow-y-auto text-sm text-wrap whitespace-pre-line"
      >
        <InnerHTMLDiv data-cy="ai-analysis-content" html={suggestion} />
      </div>
    </div>
  );
};

export default forwardRef(AIAnalysisSuggestionContainer);
